import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "p-6"
};
var _hoisted_2 = {
  "class": "flex mt-6"
};
var _hoisted_3 = {
  "class": "mx-auto"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_PBButton = _resolveComponent("PBButton");
  var _component_PBPopup = _resolveComponent("PBPopup");
  return _openBlock(), _createElementBlock("div", {
    "class": "flex",
    onKeyup: _cache[3] || (_cache[3] = _withKeys(function ($event) {
      return $data.isOpen = false;
    }, ["esc"]))
  }, [_createVNode(_component_PBPopup, {
    "class": "mx-auto",
    title: "Bequant KYC and Onboarding Flow",
    footer: false,
    "close-btn": true,
    header: true,
    "is-open": $data.isOpen,
    onClose: _cache[1] || (_cache[1] = function ($event) {
      return $data.isOpen = false;
    })
  }, {
    content: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_cache[5] || (_cache[5] = _createElementVNode("div", {
        "class": "max-w-[900px]"
      }, [_createElementVNode("p", null, [_createElementVNode("b", {
        "class": "font-bold"
      }, "Applicable Entities"), _createTextVNode(": Bequant Prime Limited and, where relevant, Bequant Pro Limited (\""), _createElementVNode("b", {
        "class": "font-bold"
      }, "Bequant"), _createTextVNode("\") ")]), _createElementVNode("p", {
        "class": "mt-6"
      }, " The Bequant.pro platform serves as the unified digital interface for client and counterparty onboarding, as well as due diligence, under Bequant Group's compliance framework. The process ensures that all clients and counterparties - both corporate and individual - undergo full KYC/AML verification prior to the activation of any trading access. "), _createElementVNode("p", {
        "class": "mt-6"
      }, [_createElementVNode("b", {
        "class": "font-bold"
      }, "Entity Scope and Responsibilities"), _createElementVNode("ul", {
        "class": "list-disc ml-6"
      }, [_createElementVNode("li", {
        "class": "my-6"
      }, [_createElementVNode("b", {
        "class": "font-bold"
      }, "Bequant Prime Limited"), _createTextVNode(" acts as the main counterparty for client and counterparty onboarding, responsible for verification, record-keeping and ongoing due diligence updates under applicable AML/CFT regulations. ")]), _createElementVNode("li", {
        "class": "my-6"
      }, [_createElementVNode("b", {
        "class": "font-bold"
      }, "Bequant Pro Limited"), _createTextVNode(", if involved in service provision to the same client and counterparty, relies on the KYC results obtained by Bequant Prime Limited under an intragroup reliance and data-sharing framework, provided that: "), _createElementVNode("ul", {
        "class": "list-[circle] ml-6"
      }, [_createElementVNode("li", {
        "class": "my-6"
      }, " Bequant Prime Limited and Bequant Pro Limited are bound by a relevant intragroup agreement governing such reliance and information sharing; and "), _createElementVNode("li", {
        "class": "my-6"
      }, " Both entities maintain full and direct access to the complete KYC file, related supporting documentation and transaction monitoring results. ")])])])]), _createElementVNode("p", {
        "class": "mt-6"
      }, [_createElementVNode("b", {
        "class": "font-bold"
      }, "Onboarding Flow")]), _createElementVNode("p", {
        "class": "mt-6"
      }, [_createElementVNode("b", {
        "class": "font-bold"
      }, "Initial Registration"), _createTextVNode(": Client / Counterparty (\""), _createElementVNode("b", {
        "class": "font-bold"
      }, "You"), _createTextVNode("\" / \""), _createElementVNode("b", {
        "class": "font-bold"
      }, "I"), _createTextVNode("\" / \""), _createElementVNode("b", {
        "class": "font-bold"
      }, "my"), _createTextVNode("\") initiates the onboarding process through this portal, by completing the required data fields and uploading the necessary onboarding documents. ")]), _createElementVNode("p", {
        "class": "mt-6"
      }, [_createElementVNode("b", {
        "class": "font-bold"
      }, "KYC Verification")]), _createElementVNode("p", {
        "class": "mt-6"
      }, [_createTextVNode(" Verification is conducted internally by Bequant's Compliance Team and through external providers of Bequant (e.g., SumSub or equivalent) (collectively, the \""), _createElementVNode("b", {
        "class": "font-bold"
      }, "Authorised Bequant Service Providers"), _createTextVNode("\"). The verification process includes identity validation, proof of address, sanctions and PEP screening, source of funds and source of wealth verification, as well as other relevant data (collectively, the \""), _createElementVNode("b", {
        "class": "font-bold"
      }, "Personal Data"), _createTextVNode("\"). ")]), _createElementVNode("p", {
        "class": "mt-6"
      }, " By proceeding further, You confirm that You agree to share your Personal Data with Bequant and the Authorised Bequant Service Providers, exclusively for the purposes of onboarding and Your subsequent use of Bequant's services. "), _createElementVNode("p", {
        "class": "mt-6"
      }, [_createElementVNode("b", {
        "class": "font-bold"
      }, "Compliance Review"), _createTextVNode(": ")]), _createElementVNode("p", {
        "class": "mt-6"
      }, " Bequant's Prime's Compliance Team reviews all data, approves or escalates any cases involving enhanced due diligence (EDD), and records the decision in the internal compliance log. "), _createElementVNode("p", {
        "class": "mt-6"
      }, [_createElementVNode("b", {
        "class": "font-bold"
      }, "Account Activation"), _createTextVNode(": ")]), _createElementVNode("p", {
        "class": "mt-6"
      }, " Once approved, You will be granted access to the platform services. "), _createElementVNode("p", {
        "class": "mt-6"
      }, [_createElementVNode("b", {
        "class": "font-bold"
      }, "Data Storage and Retention"), _createTextVNode(": ")]), _createElementVNode("p", {
        "class": "mt-6"
      }, " Your Personal Data is securely stored on Bequant's servers in compliance with GDPR and applicable AML and data protection laws. Data retention is maintained for seven (7) years following the termination of the business relationship, or for a longer duration if required by applicable legislation. Bequant reserves the right, acting in its sole discretion, to extend such retention period up to ten (10) years, where legally permissible. "), _createElementVNode("p", {
        "class": "mt-6"
      }, [_createElementVNode("b", {
        "class": "font-bold"
      }, "Ongoing Monitoring")]), _createElementVNode("p", {
        "class": "mt-6"
      }, " You remain subject to ongoing monitoring, including periodic review, transaction screening, and trigger-based re-verification where risk indicators arise. You agree to provide updated information and any clarifications reasonably requested by Bequant from time to time for the purposes of KYC refresh and ongoing due diligence. "), _createElementVNode("p", {
        "class": "mt-6"
      }, [_createTextVNode(" By pressing \""), _createElementVNode("b", {
        "class": "font-bold"
      }, "Proceed"), _createTextVNode("\", you agree to "), _createElementVNode("b", {
        "class": "font-bold"
      }, "Bequant Prime Limited"), _createTextVNode(" and/or "), _createElementVNode("b", {
        "class": "font-bold"
      }, "Bequant Pro Limited's"), _createTextVNode(", as relevant, Terms of Business and acknowledge your understanding of the "), _createElementVNode("b", {
        "class": "font-bold"
      }, "Bequant KYC and Onboarding Flow"), _createTextVNode(". ")])], -1)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_PBButton, {
        "class": "m-auto",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return $data.isOpen = false;
        })
      }, {
        "default": _withCtx(function () {
          return _toConsumableArray(_cache[4] || (_cache[4] = [_createTextVNode(" Close ", -1)]));
        }),
        _: 1
      })])])];
    }),
    _: 1
  }, 8, ["is-open"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("a", {
    href: "#",
    "class": "m-auto text-[#979797] font-bold border-b border-dashed border-[#979797] transition-all duration-250 hover:opacity-80",
    onClick: _cache[2] || (_cache[2] = _withModifiers(function ($event) {
      return $data.isOpen = true;
    }, ["prevent"]))
  }, " Bequant KYC and Onboarding Flow ")])], 32);
}